import { render, staticRenderFns } from "./ConsumerDetails.vue?vue&type=template&id=1d3dfae7&scoped=true&"
import script from "./ConsumerDetails.vue?vue&type=script&lang=js&"
export * from "./ConsumerDetails.vue?vue&type=script&lang=js&"
import style0 from "./ConsumerDetails.vue?vue&type=style&index=0&id=1d3dfae7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3dfae7",
  null
  
)

export default component.exports